<template>
<div class="item f-l fdqy-c">
	<div class="f-t fg1">
		<div  class="fg1 f-l fdqy-c" style="height: 42px;">
			<p class="text-line2 text-lue" :title="filename">{{filename}}</p>
		</div>
		<p class="fs12" style="width: 120px;border-top: 1px solid #EDEEF5;padding: 1px 0px 0px 5px">
			{{myfun.sizeshow(nowsize)}}/{{myfun.sizeshow(allsiz)}}
		</p>
	</div>
	<div class="p-r" style="flex-shrink: 0;width: 60px;height: 60px;overflow: hidden;">
		<div class="p-a" style="left: 10px;top: 10px;">
			<p style="width: 40px;height: 40px;border-radius: 50%;background: #409EFF;" class="p-r">
				<i :class="iclass" class="p-a myicon"></i>
			</p>
		</div>
		<el-progress :percentage="nowsize/allsiz*100" :show-text="false" type="circle"></el-progress>
	</div>
</div>
</template>

<script>
import bus from "../plugins/bus.js"
export default{
	name:'linelist',
	data() {
		return {
		}
	},
	props:{
		test:{
			type:Object
		},
		type:{
			type:String
		}
	},
	computed:{
		filename(){
			if(this.test.file.typ==='analyse'){
				return this.test.value.name + "(试卷分析)."+this.test.test.analyseSuffix
			}
			return this.test.value.name+"."+this.test.test.suffix
		},
		nowsize(){
			return this.test.file.nowsize
		},
		allsiz(){
			return this.test.file.size
		},
		iclass(){
			if(this.nowsize>=this.allsiz){
				return "el-icon-check"
			}
			if(this.type==="up"){
				return "el-icon-top up"
			}
			return "el-icon-bottom down"
		}
	},
	watch:{
		nowsize(){
			if(this.test.file.typ==='analyse'){
				if(this.type==="up"&&this.nowsize===this.allsiz){
					const formdata = new FormData()
					formdata.append("key",this.test.file.key)
					formdata.append("data",JSON.stringify({id:this.test.test.id,upsize:this.nowsize}))
					this.axios.post("data:testanalyseuped",formdata).then((e)=>{
						if(!e) return
						this.myfun.messageSuc(this.filename+"上传成功")
					})
				}
				return
			}
			bus.$emit("up"+this.test.test.id,this.nowsize)
			if(this.type==="up"&&this.nowsize===this.allsiz){
				const formdata = new FormData()
				formdata.append("key",this.test.file.key)
				formdata.append("data",JSON.stringify({id:this.test.test.id,upsize:this.nowsize}))
				this.axios.post("data:testuped",formdata).then(e=>{
					if(!e) return
					this.myfun.messageSuc(this.filename+"上传成功")
				})
			}
		}
	}
}
</script>

<style scoped>
.item{
	margin: 5px 10px 5px 5px;
	border-radius: 5px;
	padding: 5px;
	border: 1px solid #cccccc;
	box-shadow: 3px 3px 3px #999999;
}
.myicon{
	display: block;
	width: 22px;
	height: 22px;
	text-align: center;
	font-size: 22px;
	color: #fff;
	top: 9px;
	left: 9px;
	font-weight: 500;
}
.up{
	left: 8px;
	animation: up 1s 0s infinite linear;
}
.down{
	left: 9px;
	animation: down 1s 0s infinite linear;
}
@keyframes up{
	0% {
		top:15px;
	}
	100% {
		top: 3px;
	}
}
@keyframes down{
	0% {
		top:3px;
	}
	100% {
		top: 15px;
	}
}
</style>
